import validate from "/app/node_modules/.pnpm/nuxt@3.17.2_@parcel+watcher@2.5.1_@types+node@22.15.17_db0@0.3.2_eslint@9.26.0_jiti@2.4_7b71c36ff82434ae125e053a37f62370/node_modules/nuxt/dist/pages/runtime/validate.js";
import discord_45global from "/app/middleware/discord.global.ts";
import legacy_45job_45posting_45global from "/app/middleware/legacyJobPosting.global.ts";
import legacy_45news_45global from "/app/middleware/legacyNews.global.ts";
import legacy_45user_45global from "/app/middleware/legacyUser.global.ts";
import username_45user_45global from "/app/middleware/usernameUser.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.2_@parcel+watcher@2.5.1_@types+node@22.15.17_db0@0.3.2_eslint@9.26.0_jiti@2.4_7b71c36ff82434ae125e053a37f62370/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  discord_45global,
  legacy_45job_45posting_45global,
  legacy_45news_45global,
  legacy_45user_45global,
  username_45user_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "sidebase-auth": () => import("/app/node_modules/.pnpm/@sidebase+nuxt-auth@0.10.1_magicast@0.3.5_next-auth@4.21.1_next@13.5.11_@babel+core@7.2_810d33bd76d134a37adbe8c67efafdaf/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/sidebase-auth.js")
}